import HistoryCheckboxes from "./HistoryCheckboxes";

export default HistoryCheckboxes;
